<template>
  <div class="commentaireListInput">
    <b-tooltip
      :label="$t('general.composants.commentaireListInput.tooltipInfo')"
      :active=!error>
      <b-tooltip
        :label="labelError"
        type="is-danger"
        :active=error>
          <qd-loader :active="isLoading"
                     :can-cancel="true">
            <b-input
                  :class="{'error': error}"
                  type="textarea"
                  v-model="commentaire"
                  :disabled="disabled"
                  :rows="2"
                  @blur="majComAsync"
                  @dblclick.native="openPopup = true"
                  >
            </b-input>
        </qd-loader>
      </b-tooltip>
    </b-tooltip>
    <b-modal
      @close="openPopup = false"
      :active="openPopup"
      class="modal"
      width="380px"
      has-modal-card>
      <popupCommentaireListInput
        v-model="commentaire"
        :maj="maj"
        :id="id"/>
    </b-modal>
  </div>
</template>
<script>
import validationGeneral from '@/services/validation/validation';
import popupCommentaireListInput from './p_commentaireListInput';

export default {
  name: 'InputTierNomCommercial',
  props: {
    value: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    maj: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      openPopup: false,
      isLoading: false,
      oldValue: null,
      labelError: this.$t('general.composants.commentaireListInput.tooltipError'),
    };
  },
  components: {
    popupCommentaireListInput,
  },
  computed: {
    commentaire: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    async majComAsync() {
      if (!this.id
      || this.commentaire === undefined
      || this.commentaire === this.oldValue) {
        return;
      }
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.error = false;
      this.isLoading = true;
      try {
        this.error = false;
        await this.maj(this.id, this.commentaire);
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          if (this.messages.length > 0) {
            this.labelError = this.messages
              .map(msg => {
                return this.$t(
                  msg.message,
                  msg.parametres ? msg.parametres : {});
              })
              .join(', ');
          } else {
            this.labelError = this.$t('general.composants.commentaireListInput.tooltipError');
          }
        }
        this.error = true;
        throw e;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.oldValue = this.value;
  },
};
</script>

<style>

</style>
